import instance from '../utils/axios';

class ElectronicInventoryBalanceService {
    async getList(pageIndex, warehouseId, skuInfoStr) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            warehouseIds: warehouseId,
            skuId: skuInfoStr,
            sortField: 'createTime desc',
        }
        return await instance.post('/electronerp/transaction/getNow', data);
    }
    async getDetailList(pageIndex, warehouseId, skuInfoStr) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            dictionaryNames: "skuUnit.dict_psi_sku_unit",
            warehouseIds: warehouseId,
            skuId: skuInfoStr,
            sortField: 'createTime desc',
        }
        return await instance.post('/electronerp/transaction/getNow', data);
    }
    async getBinAndQuantity(pageIndex, warehouseId, skuInfoStr) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
            pageSize: 10,
            dictionaryNames: "warehouseId.psi_warehouse",
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            warehouseId: warehouseId,
            skuId: skuInfoStr,
        }
        return await instance.post('/electronerp/elePsi/transaction/getBinAndQuantity', data);
    }
    async getZLSelectDict(dictionaryName) {
      return await instance.get('/crm/common/CommonApi/GetZLSelectDict?dictionaryName='+dictionaryName);
    }
}

export default new ElectronicInventoryBalanceService();